module.exports = __webpack_public_path__ + "static/media/icon-receive-with-border.a28e2bb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-receive-with-border.svg
// module id = 1229
// module chunks = 19